import { Controller } from "@hotwired/stimulus"

// Collapsible Help Section Controller
// Handles expand/collapse of help sections
//
// Usage:
//   <div data-controller="help-collapsible">
//     <button data-action="click->help-collapsible#toggle">Toggle</button>
//     <div data-help-collapsible-target="content">Content...</div>
//   </div>
export default class extends Controller {
  static targets = ["content"]

  toggle(event) {
    event.preventDefault()
    const button = event.currentTarget
    const targetId = button.dataset.target
    const targetElement = document.getElementById(targetId)

    if (!targetElement) return

    const isExpanded = button.getAttribute('aria-expanded') === 'true'

    if (isExpanded) {
      this.collapse(button, targetElement)
    } else {
      this.expand(button, targetElement)
    }
  }

  expand(button, element) {
    button.setAttribute('aria-expanded', 'true')
    element.classList.add('show')
  }

  collapse(button, element) {
    button.setAttribute('aria-expanded', 'false')
    element.classList.remove('show')
  }
}
